export class Organisation {
  org_id: number;
  oname: string;
  address1: string;
  address2: string;
  city: string;
  state: string;
  zip: number;
  contact_no: number;
  usereid: string;
  org_code: string;
  org_eid: string;
  opurl: any;
}
